<template>
  <v-container>
    <v-breadcrumbs :items="breadcrumbs" class="pl-0 py-1">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-form
      ref="editGroupForm"
      v-model="editGroupFormValid"
      lazy-validation
    >
    <v-card class="mt-3 mb-4">
      <v-card-title class="px-3 py-2">
        <h3>グループ情報</h3>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="px-3 py-2">
        <v-text-field
          v-model="inputEditGroup.name"
          label="グループ名*"
          required
          :rules="nameRules"
          outlined
          clearable
          dense
        ></v-text-field>
        <v-text-field
          v-if="role==='ADMIN'"
          v-model="inputEditGroup.email"
          label="オーナーのメール*"
          required
          :rules="emailRules"
          outlined
          clearable
          dense
        ></v-text-field>
        <v-autocomplete
          v-if="role==='ADMIN'"
          v-model="plants"
          :disabled="isUpdating"
          :items="allplants"
          filled
          chips
          color="blue-grey lighten-2"
          label="共有発電所"
          item-text="name"
          item-value="id"
          multiple
          return-object
          :search-input.sync="search"
          @change="search = ''"
          no-data-text="該当データがありません。"
        >
          <template v-slot:selection="data">
            <v-chip
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              @click="data.select"
              @click:close="remove(data.item)"
            >
              {{ data.item.name }}
            </v-chip>
          </template>
          <template v-slot:item="data">
            <template v-if="typeof data.item !== 'object'">
              <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
            <v-list-item-content>
              <v-list-item-title v-html="data.item.name"></v-list-item-title>
            </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-card-text>
    </v-card>
    </v-form>
    <v-spacer></v-spacer>
    <div class="text-right">
      <v-btn class="primary" @click="confirmUpdate" width=165>保存</v-btn>
    </div>
  </v-container>
</template>

<script>
import {store} from '@/store';
export default {
  name: "EditGroup",
  data() {
    return {
      role: localStorage.getItem('drs_role'),
      group_id: this.$route.params.groupId,
      editGroupFormValid: true,
      isUpdating: false,
      inputEditGroup: {
        name: null,
        email: null,
        add_plants: [],
        remove_plants: [],
          
      },
      emailRules: [
        value => !!value || 'メルアドレスを入力してください.',
        value => value && value.length <= 50 || 'メールアドレスの長さは50文字以内にしてください。',
        value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || '有効なメールアドレスを入力してください。'
        }
      ],
      plants: [],
      allplants: [],
      original_plants: [],
      breadcrumbs: [
        {
            text: "グループ",
            disabled: false,
            exact: true,
            to: "/group"
        },
        {
            text: "",
            disabled: false,
            exact: true,
            to: "",
        },
        {
            text: "グループ編集",
            disabled: false,
            exact: true,
        },
      ],
      nameRules: [
        value => (!!value && !!value.trim()) || 'グループ名を入力してください。',
        value => value && value.length <= 50 || 'グループ名の長さは50文字以内にしてください。',
      ],
      search: null,
    }
  },
  watch: {
    isUpdating (val) {
        if (val) {
            setTimeout(() => (this.isUpdating = false), 3000)
        }
    },
    select() {
        this.search = '';
    }
  },

  methods: {
    getPlants() {
      this.axios.get("/api/group/plants/"+ this.group_id)
      .then((response) => {
        response.data.plants.forEach(element => {
          this.plants.push(element);
        });
        this.inputEditGroup.name = response.data.group.name;
        this.inputEditGroup.email = response.data.group.email;
        this.original_plants = JSON.parse(JSON.stringify(this.plants));

        this.breadcrumbs[1].text = response.data.group.name;
        this.breadcrumbs[1].to = '/group/'+response.data.group.id;
      })
      .catch(() => {
        store.showErrorDialog("エラーが発生しました。再度試してください。");
      });
    },
    getAllPlants() {
      this.allplants = [];
      this.axios.get("/api/group/all-plants/")
      .then((response) => {
        this.allplants = response.data;
      })
      .catch(() => {
        store.showErrorDialog("エラーが発生しました。再度試してください。");
      })
    },

    remove(item) {
      const plant_index =  this.plants.findIndex(x => x.id== item.id)
      this.plants.splice(plant_index, 1);
      const status = this.original_plants.find(x => x.id == item.id);
      if (status) {
        this.inputEditGroup.remove_plants.push(item);
      }
    },
    confirmUpdate() {
      if (this.$refs.editGroupForm.validate()) {
        const confirmDialog = {
          title: '編集確認',
          content: "グループの情報を編集します。よろしいですか。",
          onAgree: () => this.update(),
          onDisagree: null,
        };
        store.showConfirmDialog(confirmDialog);
      }
    },

    update() {
      if (this.$refs.editGroupForm.validate()) {
        for(var idx in this.plants) {
          const existed_plant = this.original_plants.find(x => x.id == this.plants[idx].id);
          if (!existed_plant) {
            this.inputEditGroup.add_plants.push(this.plants[idx]);                
          }
        }
        store.showLoadingOverlay(true);
        this.axios.post("/api/group/" +this.group_id+ "/edit/", this.inputEditGroup)
        .then(() => {
          store.showSuccessDialog("グループが編集されました。");
          this.$router.push('/group/'+ this.group_id);
        })
        .catch((error)=>{
          if (error.response.status == 400) {
            if('existed_group' in error.response.data) {
              store.showErrorDialog("グループ名が存在されました。他の名で再度試してください。");
            }
            
          }else {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
          }
        })
        .then(() => {
          store.showLoadingOverlay(false);
        });
      }
    }
  },

  created() {
    this.getAllPlants();
    this.getPlants();
  },
}
</script>
<style scoped>
>>>.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
    border-bottom: none;
}
</style>
